import { Component, EventEmitter, Input, OnInit, Output, SimpleChange } from '@angular/core';

@Component({
  selector: 'app-custom-checkbox-dropdown-common',
  templateUrl: './custom-checkbox-dropdown-common.component.html',
  styleUrls: ['./custom-checkbox-dropdown-common.component.css']
})
export class CustomCheckboxDropdownCommonComponent implements OnInit {

  @Input() allDataValue: any; 
  @Input() selectedIds: any;
  @Input() dropDownSettings;
  @Output() satesChanges = new EventEmitter<string[]>();
  selectedItems = [];
  unSelectedItems = [];
  dataValue = [];

  constructor() { }

  ngOnInit(): void {
    this.allDataValue?.length > 0 ? this.setValue() : '';
  }

  ngOnChanges(changes: SimpleChange){
    this.setValue();
  }

  setValue(){
    this.allDataValue = this.allDataValue?.map(m => ({ ...m, isChecked: false }));
    this.dataValue = this.allDataValue?.filter(m => !m[this.dropDownSettings?.isRequested] && !m[this.dropDownSettings?.isActive]);

    // this.dataValue = this.dataValue?.map(m => ({ ...m, isChecked: false }));
    
    if(this.selectedIds?.length > 0){
      // const dataIdsArray: number[] = this.selectedIds?.split(',').map(id => parseInt(id.trim(), 10));

      this.selectedIds.forEach((id, index) => {
        const foundData = this.dataValue.find(data => data[this.dropDownSettings.dataId] === id[this.dropDownSettings.dataId]);
        if (foundData) {
          foundData['isChecked'] = true;
          this.selectedItems.push(foundData);
        }

        index == this.selectedIds.length - 1 ? this.getSelectedData() : '';
      });
    }else{
      this.getSelectedData();
    }

    
  }

  onSelectionChange(id) { 
    if(this.dropDownSettings.multiple){
    this.dataValue.forEach(x =>{
      if( x[this.dropDownSettings.dataId] == id){
        x.isChecked = !x.isChecked;
        
      }else if(id == 0){
        x.isChecked = 
        this.selectedItems?.length == this.dataValue?.length ? false : true;
      }
    })
    }else{
      this.dataValue.forEach(x =>{
          x.isChecked = x[this.dropDownSettings.dataId] == id ? true : false;
      });
    }
      this.getSelectedData();
      this.satesChanges.emit(this.selectedItems);
  }

  getSelectedData() {
      this.unSelectedItems = this.allDataValue.filter(x =>x.isChecked === false);
      this.selectedItems = this.allDataValue.filter(x =>x.isChecked === true);
  }
}
